

























































import { Component, Prop, Vue } from "vue-property-decorator"
import AppProgramaDia from "@/components/Programa/AppProgramaDia.vue";
import { Programa } from "@/Interfaces/Programa/Programa";

@Component({
  components: {
    AppProgramaDia,
  },
})
export default class AppPrograma extends Vue {
  @Prop({ required: true }) programa: Programa
  @Prop({ default: false }) becario: boolean
}
